export class XeroEntityDeleteRequest{
    public customerId!:number;
    public clientId!:number;
}